import { AnalyticsEvents } from '../types/events'
import { buildTrackedRoute, resolveEventTypes } from '../utils/page-hit'
import { clientPortalAnalyticsService } from '../services/clientportal-analytics.service'
import type { AnalyticsProvider } from './base.provider'

// Turns a PAGE_VIEW into product page-hit events and sends each to the Pendo endpoint.
export class PendoAnalyticsProvider implements AnalyticsProvider {
  name = 'PendoAnalytics'

  constructor(private readonly flavor: string) {}

  track(event: string, properties?: Record<string, unknown>): void {
    if (event !== AnalyticsEvents.PAGE_VIEW) return

    const path = (properties?.pagePath as string) ?? ''
    const locationId = properties?.locationId as string | undefined
    if (!path || !locationId) return

    const contactId = properties?.contactId as string | undefined
    const routeName = properties?.routeName as string | undefined
    const route = buildTrackedRoute(path, properties?.activeTab as string | undefined)

    for (const eventType of resolveEventTypes(path, routeName, this.flavor === 'gokollab')) {
      clientPortalAnalyticsService.trackPageHit({ eventType, locationId, path: route, flavor: this.flavor, contactId })
    }
  }

  identify(): void {
    // no-op — context arrives via properties
  }
}
